import {gql, MutationHookOptions, useMutation} from '@apollo/client'

export const ADD_INTERNAL_RENTAL_COMMENT = gql`
  mutation ($rentalId: ID!, $comment: String!) {
    addInternalRentalComment(rentalId: $rentalId, comment: $comment) {
      type
      comment {
        id
        comment
        createdAt
        createdByUser {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`

export type AddInternalRentalCommentData = {
  addInternalRentalComment: {
    type: string
    comment: {
      id: string
      comment: string
      createdAt: string
      createdByUser: {
        id: string
        firstName: string | null
        lastName: string | null
        email: string | null
      }
    } | null
  }
}

export type AddInternalRentalCommentVars = {
  rentalId: string
  comment: string
}

export const useAddInternalRentalComment = (options?: MutationHookOptions<AddInternalRentalCommentData, AddInternalRentalCommentVars>) => {
  return useMutation<AddInternalRentalCommentData, AddInternalRentalCommentVars>(ADD_INTERNAL_RENTAL_COMMENT, options as any)
}
